import { faThumbsUp } from '@fortawesome/pro-solid-svg-icons'
import { ActionButton, HeadingItem } from 'components'
import { ScrollView } from 'devextreme-react'
import { Popup } from 'devextreme-react/popup'
import React, { FC } from 'react'
import { versions } from 'resources'
import { VersionHistory } from 'types'
import './change-log-pop-up.scss'

type Props = {
    visible: boolean,
    appVersion: string | undefined,
    onClickOk: () => void,
}

export const ChangeLogPopUp: FC<Props> = ({ visible, appVersion, onClickOk }) => {
    
    const splitVersion = (version: string | undefined): string[] => version?.split('-') ?? ['']

    const versionParts: string[] = splitVersion(appVersion)
    const changeLogs: string[] = versions?.filter(log => splitVersion(log.version)[0] === versionParts[0]).reduce((allChanges: string[], log: any) => [...allChanges, ...log.changes], [])

    return (
        <Popup
            visible={changeLogs?.length > 0 && visible}
            dragEnabled={false}
            closeOnOutsideClick={false}
            showTitle={false}
            width={325}
            height={450}
        >
            <HeadingItem text={`What's new in ${versionParts[0]}?`} />
            <div className={'change-log-pop-up-container'}>
                <div className={'change-log-pop-up-content'}>
                    <ScrollView>
                        <ul className="content">
                            {changeLogs.map((log) => {
                                return (<li key={log}><span>{log}</span></li>)
                            })}
                        </ul>
                    </ScrollView>
                </div>
                <div className={'change-log-pop-up-button'}>
                    <ActionButton
                        icon={faThumbsUp}
                        iconSize={'1x'}
                        buttonText={'Ok'}
                        buttonColor={'#82BC24'}
                        onClick={onClickOk}
                    />
                </div>
            </div>
        </Popup>
    )
}